import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TvCarteleraComponent from '../components/TvCarteleraComponent';
import { validateSession } from '../utils/functions';

class TvCarteleraPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        }
    }

    async componentDidMount() {
        // true = no exigir caja abierta: esto es configuración de lo que se muestra, no
        // operación de mostrador. Mismo criterio que las imágenes de portada.
        let role = await validateSession(true)
        this.setState({ checked: true, role: role });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (
                <div class="container-fluid">
                    <div class="row">
                        <SidebarComponent itemSelected={50} role={this.state.role}/>
                        <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent title="Extras" subtitle="Cartelera TV"/>
                                <TvCarteleraComponent />
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }
}

export default TvCarteleraPage;
